"use client";
import { MinusIcon, PlusIcon } from "lucide-react";
import React from "react";

const QuestionsAccordian = ({
  heading = "Accordian Heading",
  subHeading = "",
  questions = [],
}: {
  heading?: string;
  subHeading?: string;
  questions?: { question: string; answer: string }[];
}) => {
  const [expanded, setExpanded] = React.useState([0]);
  const handleExpand = (index: number) =>
    setExpanded((prev) => {
      if (prev.includes(index)) {
        return prev.filter((i) => i !== index);
      }
      return [...prev, index];
    });
  return (
    <div className="">
      <div className="sm:mb-20 mb-10 flex flex-col gap-3">
        <h2 className="font-semibold text-[#131b31] max-w-[30rem] sm:max-w-[35rem] ">
          {heading}
        </h2>
        {subHeading && (
          <p className="max-w-[35rem] text-muted-2-foreground">
            {subHeading}
          </p>
        )}
      </div>

      {/* Questions */}
      {questions.map((item, index) => (
        <div
          key={index}
          className="flex flex-col gap-2 lg:mb-8 sm:mb-6 xs:mb-4 mb-2"
        >
          <div className="flex lg:justify-start justify-between items-center gap-4 mb-4">
            <h3 className=" font-medium sm:font-semibold lg:text-nowrap text-[16px] xs:text-[18px] sm:text-[22px] leading-[130%]">
              {item.question}
            </h3>
            <button
              className=" cursor-pointer hover:bg-gray-200 rounded-full p-2"
              aria-label="Expand"
              aria-expanded={expanded.includes(index)}
              onClick={() => handleExpand(index)}
            >
              {expanded.includes(index) ? <MinusIcon /> : <PlusIcon />}
            </button>
          </div>
          <p
            className={`text-muted-2-foreground max-w-[45rem] text-justify whitespace-pre-line ${
              expanded.includes(index) ? "" : "hidden"
            }`}
          >
            {item.answer}
          </p>
        </div>
      ))}
    </div>
  );
};

export default QuestionsAccordian;
